import React, { Component } from 'react';
import { AutoComplete } from '../../../shared-components';
import PropTypes from 'prop-types';
import { getUserEmailFromLocalStorage } from '../../../../Firebase/localStorageForUserInfo';
import {
  TOPIC_NAME_MISSING_ERROR_KEY,
  TOPIC_NAME_EXISTS_ERROR_KEY,
  CATEGORIES_KEY,
  DESCRIPTION_KEY,
  MAXIMUM_DESCRIPTION_LENGTH,
  MAXIMUM_TOPIC_NAME_LENGTH,
  EDIT_TOPIC_TYPE_TAG
} from '../constants/constants';
import { t } from 'i18next';
import { 
  UPLOAD_DATA_TOPIC_DETAILS_MODAL_I18N_KEYS as MY_I18N_KEYS, 
  UPLOAD_DATA_TOPIC_DETAILS_MODAL_I18N_PREFIX as MY_I18N_PREFIX 
} from '../constants/i18n/UploadDataTopicDetailsModali18nConstants';

const initialState = {
  topicName: '',
  description: '',
  categories: [],
  status: false,
  hasUploadedData: false,
  hasCrawledData: false
};

class BasicTopicDetailsForm extends Component {
  static propTypes = {
    createTopics:                               PropTypes.func.isRequired,
    allCategories:                              PropTypes.array.isRequired,
    resetAddTopicForm:                          PropTypes.bool.isRequired,
    createOrUpdateTopicsBeginStatus:            PropTypes.bool.isRequired,
    allTopicNames:                              PropTypes.array.isRequired,
    topicData:                                  PropTypes.object,
    type:                                       PropTypes.string.isRequired,
    toggleModal:                                PropTypes.func,
    handleCancelEdit:                           PropTypes.func
  };

  constructor(props) {
    super(props);
    let topicData = props.type == EDIT_TOPIC_TYPE_TAG ? JSON.parse(JSON.stringify(props.topicData)) : JSON.parse(JSON.stringify(initialState));
    let originalTopicName = '';
    let originalSendEmailWhenReady = false;
    if (props.type == EDIT_TOPIC_TYPE_TAG) {
      originalTopicName = topicData.topicName;
      originalSendEmailWhenReady = !!topicData.topicReadyNotificationEmailAddress;
    }
    
    this.state = {
      error: {},
      topicData: topicData,
      allTopicNames: [],
      sendEmailWhenReady: originalSendEmailWhenReady,
      originalTopicName: originalTopicName
    };
  }

  componentDidMount() {
    this.setState({ allTopicNames: this.props.allTopicNames});
  }

  static getDerivedStateFromProps(nextProps, prevState){
    let update = {};

    if (nextProps.resetAddTopicForm) {
      update.topicData = JSON.parse(JSON.stringify(initialState));
      update.error = {};
    }

    if (nextProps.allTopicNames && nextProps.allTopicNames.length) {
      if (JSON.stringify(nextProps.allTopicNames) !== JSON.stringify(prevState.allTopicNames)) {
        update.allTopicNames = nextProps.allTopicNames;
      }
    }
    return update;
  }  

  formSubmit = event => {
    event.preventDefault();
    const { topicData } = this.state;
    const { createTopics } = this.props;
    if (this.validateTopicDetailsForm()) {
       return false;
    } else {
       createTopics(topicData);
    }
  };

  validateTopicDetailsForm = () => {
    let formError     = false;
    let { topicData } = this.state;
    let error         = {};
    if (!topicData.topicName) {
      error[TOPIC_NAME_MISSING_ERROR_KEY] = true;
      formError = true;
    }
    else if (this._isTopicNameAlreadyTaken(topicData.topicName)) {
      error[TOPIC_NAME_EXISTS_ERROR_KEY] = true;
      formError = true;
    }
    this.setState({ error });
    return formError;
  };

  _isTopicNameAlreadyTaken(topicName) {
    const { originalTopicName, allTopicNames } = this.state;
    return (allTopicNames.includes(topicName) && (topicName !== originalTopicName));
  }

  selectedTags = (value, key) => {
    let { topicData, error } = this.state;
    topicData[key] = value;
    if (value.length) delete error[key];
    this.setState({ topicData, error });
  };

  setFormValues = event => {
    let { topicData, error } = this.state;
    if (event.target.name === DESCRIPTION_KEY && event.target.value.length >= MAXIMUM_DESCRIPTION_LENGTH) {
      event.target.value.slice(0, MAXIMUM_DESCRIPTION_LENGTH);
      return false;
    }
    topicData[event.target.name] = event.target.value;
    delete error[event.target.name];
    this.setState({
      error,
      topicData,
    });
  };

  setWhetherAndWhereToEmailWhenTopicReady() {
    const previousSendEmailWhenReadyState        = this.state.sendEmailWhenReady;
    const newSendEmailWhenReadyState             = !previousSendEmailWhenReadyState;
    const topicReadyNotificationEmailAddress     = newSendEmailWhenReadyState ? getUserEmailFromLocalStorage() : null;
    let { topicData }                            = this.state;
    topicData.topicReadyNotificationEmailAddress = topicReadyNotificationEmailAddress;

    this.setState({
        sendEmailWhenReady: newSendEmailWhenReadyState,
        topicData:          topicData
    });
  }

  isThereTopicNameFormError(error) {
    return (error[TOPIC_NAME_MISSING_ERROR_KEY] || error[TOPIC_NAME_EXISTS_ERROR_KEY]);
  }

  getTopicNameFormErrorMessage(error) {
    let errorMessage = '';
    if (error) {
      if (error[TOPIC_NAME_MISSING_ERROR_KEY]) {
        errorMessage = this.getI18nText(MY_I18N_KEYS.topic_name_missing_error);
      }
      else if (error[TOPIC_NAME_EXISTS_ERROR_KEY]) {
        errorMessage = this.getI18nText(MY_I18N_KEYS.topic_name_already_exists_error);
      }
    }
    return errorMessage;
  }

  handleOnCancelButtonClick() {
    if (this.props.type == EDIT_TOPIC_TYPE_TAG) {
      this.props.handleCancelEdit();
    } else {
      this.props.toggleModal(false);
    }
  }

  getI18nAbsoluteKey(relativeKey) {
    return MY_I18N_PREFIX + "." + relativeKey;
  }

  getI18nText(relativeKey) {
    const absoluteKey = this.getI18nAbsoluteKey(relativeKey);
    return t(absoluteKey);
  }

  render() {
    const { allCategories, createOrUpdateTopicsBeginStatus, type } = this.props;
    const { topicData, sendEmailWhenReady, error } = this.state;

    return (
        <form noValidate onSubmit={e => this.formSubmit(e)}>
            <div className="modal-body" id="topic-details-form">
              <div className="form-group row">
                <label className="col-sm-4 col-form-label">{this.getI18nText(MY_I18N_KEYS.topic_name)}</label>
                <div className="col-sm-8 topic-input-group">
                    <input
                    type="text"
                    maxLength={MAXIMUM_TOPIC_NAME_LENGTH}
                    className={`form-control add-topic-input ${
                        error && this.isThereTopicNameFormError(error) ? 'input-error' : ''
                    }`}
                    defaultValue={topicData.topicName}
                    name="topicName"
                    onChange={e => this.setFormValues(e)}
                    />
                </div>
                <div className="error-container">
                    <span className="instruction-msg error">
                    {this.getTopicNameFormErrorMessage(error)}
                    </span>
                </div>
              </div>
              <div className="form-group row">
                <label className="col-sm-4 col-form-label"> {this.getI18nText(MY_I18N_KEYS.description)}</label>
                <div className="col-sm-8 topic-input-group">
                    <textarea
                    className="form-control add-topic-input"
                    value={topicData.description}
                    name="description"
                    onChange={e => this.setFormValues(e)}
                    ></textarea>
                </div>
                <span className="instruction-msg">{this.getI18nText(MY_I18N_KEYS.description_instructions)}</span>
              </div>
              <div className="form-group row">
                <label className="col-sm-4 col-form-label">{this.getI18nText(MY_I18N_KEYS.categories)}</label>
                <div className="col-sm-8 topic-input-group">
                    <div className="add-topic-input">
                    <AutoComplete
                        suggestions={allCategories}
                        selectedTags={e => this.selectedTags(e, CATEGORIES_KEY)}
                        tagData={topicData[CATEGORIES_KEY]}
                    />
                    </div>
                </div>
                <span className="instruction-msg">
                    {this.getI18nText(MY_I18N_KEYS.categories_instructions)}
                </span>
              </div>
              <div className="form-group row">
                <label className="col-sm-4 col-form-label"> {this.getI18nText(MY_I18N_KEYS.email_when_ready)}</label>
                <div className="col-sm-8 topic-input-group">
                    <input
                    className="styled-checkbox"
                    type="checkbox"
                    id="email-checkbox"
                    onChange={() => this.setWhetherAndWhereToEmailWhenTopicReady()}
                    checked={sendEmailWhenReady}
                    />
                </div>
              </div>
            </div>
            <div className="modal-footer">
                <button
                type="button"
                className={`btn fixed-width-btn ${
                    createOrUpdateTopicsBeginStatus ? 'disabled' : ''
                }`}
                onClick={() => this.handleOnCancelButtonClick()}
                >
                {this.getI18nText(MY_I18N_KEYS.cancel_button_text)}
                </button>
                <button
                type="submit"
                className={`btn fixed-width-btn btn-submit ${
                    createOrUpdateTopicsBeginStatus ? 'disabled' : ''
                }`}
                >
                {(createOrUpdateTopicsBeginStatus) && (
                    <i className="la la-spinner la-spin" />
                )}
                {type == EDIT_TOPIC_TYPE_TAG ? this.getI18nText(MY_I18N_KEYS.save_button_text) : this.getI18nText(MY_I18N_KEYS.proceed_button_text)}
                </button>
            </div>
        </form>
    );
  }
}

export default BasicTopicDetailsForm;



// WEBPACK FOOTER //
// ./src/features/topics/components/file-upload/BasicTopicDetailsForm.js